import { useState } from 'react';
import clsx from 'clsx';
import styles from './Status.module.scss';

const Status = ({
  status,
  size,
  list,
}: {
  status: string;
  size?: string;
  list?: boolean;
}) => {
  const [hintVisible, setHintVisible] = useState<boolean>(false);
  return (
    <div className={styles.Status}>
      <div
        className={clsx(styles.status, {
          [styles.active]: status === 'active' || status === 'replacement',
          [styles.discontinued]: status === 'discontinued',
          [styles.small]: size === 'small',
        })}
        onPointerEnter={() => !list && setHintVisible(true)}
        onPointerLeave={() => !list && setHintVisible(false)}
      >
        {list && (
          <span className={clsx(styles.status_inscription)}>
            {status === 'active'
              ? 'Активен'
              : status === 'replacement'
                ? 'Активен'
                : 'Снят с производства'}
          </span>
        )}

        <span
          className={clsx(styles.status_hint, {
            [styles.visible]: hintVisible,
          })}
        >
          {status === 'active'
            ? 'Активен'
            : status === 'replacement'
              ? 'Активен'
              : 'Снят с производства'}
        </span>
      </div>
    </div>
  );
};

export default Status;
